// extracted by mini-css-extract-plugin
export default {"blockCheckbox":"TariffVariantForm_blockCheckbox__Tb+IW","checkbox":"TariffVariantForm_checkbox__LBiKm"};